import styled from "styled-components/macro";

export const BannerStyled = styled.div(({ theme }) => ({
  h1: {
    color: theme.color.brandSecondary.medium,
    fontWeight: "900",
    small: {
      color: theme.color.neutral["08"],
      fontWeight: "500",
    },
  },
}));

export const ButtonHome = styled.button`
  border: none;
`;
